<script>
import baseMixin from '@/mixins/baseMixin'
/**
 * @obsolete Please use promise-dialog.vue instead
 */
export default {
  name: 'PromiseDialogOld',
  mixins: [baseMixin],
  props: {
    width: {
      type: String,
      default: '500',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
      resolve: null,
      options: {},
    }
  },
  computed: {
    showAdditionalAction() {
      try {
        return (
          this.checkProp(this.options.actions.additional) &&
          this.options.actions.additional
        )
      } catch {
        return false
      }
    },
  },
  methods: {
    checkProp(prop) {
      try {
        return typeof prop !== 'undefined' ? prop : false
      } catch {
        return false
      }
    },
    handleOptions(providedOptions) {
      let additionalAction = null

      if (this.checkProp(providedOptions.actions.additional)) {
        additionalAction = {
          text:
            this.checkProp(providedOptions.actions.additional.text) ||
            this.checkProp(providedOptions.actions.additional) ||
            'Button',
          color: this.checkProp(providedOptions.actions.additional.color) || '',
        }
      }

      return {
        text: this.checkProp(providedOptions.text) || 'Are you sure?',
        title: this.checkProp(providedOptions.title) || 'Dialog',
        actions: {
          confirm: {
            text:
              this.checkProp(providedOptions.actions.confirm.text) ||
              this.checkProp(providedOptions.actions.confirm) ||
              'OK',
            color:
              this.checkProp(providedOptions.actions.confirm.color) || 'blue',
          },
          cancel: {
            text:
              this.checkProp(providedOptions.actions.cancel.text) ||
              this.checkProp(providedOptions.actions.cancel) ||
              'Cancel',
            color: this.checkProp(providedOptions.actions.cancel.color) || '',
          },
          additional: additionalAction,
        },
        icon: this.checkProp(providedOptions.icon) || false,
        persistent: this.checkProp(providedOptions.persistent) || true,
      }
    },
    async show(opts) {
      this.options = this.handleOptions(opts)

      return new Promise((resolve) => {
        this.resolve = resolve
        this.showDialog = true
      })
    },
    confirmEvent() {
      this.showDialog = false
      this.resolve && this.resolve('ok')
    },
    additionalEvent() {
      this.showDialog = false
      this.resolve && this.resolve('additional')
    },
    cancelEvent() {
      this.showDialog = false
      this.resolve && this.resolve('cancel')
    },
  },
}
</script>

<template>
  <div>
    <v-dialog
      v-model="showDialog"
      :width="width"
      :persistent="options.persistent"
    >
      <v-card v-if="checkProp(options)">
        <v-card-title>
          <v-icon v-if="options.icon" left>{{ options.icon }}</v-icon>
          {{ options.title }}
        </v-card-title>

        <v-card-text>
          {{ options.text }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            v-if="options.actions"
            id="dialog-cancel-btn"
            text
            class="rounded-lg ml-auto"
            :color="options.actions.cancel.color"
            :loading="loading"
            @click="cancelEvent"
          >
            {{ options.actions.cancel.text }}
          </v-btn>

          <v-btn
            v-if="showAdditionalAction"
            id="dialog-addtional-btn"
            text
            class="rounded-lg ml-auto"
            :color="options.actions.additional.color"
            :loading="loading"
            @click="additionalEvent"
          >
            {{ options.actions.additional.text }}
          </v-btn>

          <v-btn
            v-if="options.actions"
            id="dialog-confirm-btn"
            text
            class="rounded-lg ml-auto"
            :color="options.actions.confirm.color"
            :loading="loading"
            @click="confirmEvent"
          >
            {{ options.actions.confirm.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
